import { ISbStoryData } from 'storyblok-js-client';

import {
  ARTICLE_SLUGS_BY_TYPE,
  ARTICLE_MAIN_PAGE_TITLE_DICT_KEYS,
} from '@monoimin/constants';
import { ArticleStoryblok, CommonMessages } from '@monoimin/sb-types';

export const createArticleBreadcrumbs = (
  story: ISbStoryData<ArticleStoryblok>,
  messages: CommonMessages,
  customFolder?: string,
  isStandalonePage?: boolean
) => {
  const { content } = story;

  const { articleType, heading } = content;
  const customFolderName = messages?.[customFolder as keyof typeof messages];
  const mainPage = {
    name:
      customFolderName ||
      messages[ARTICLE_MAIN_PAGE_TITLE_DICT_KEYS[articleType]],
    item: `/${customFolder || ARTICLE_SLUGS_BY_TYPE[articleType]}`,
  };
  const homePage = {
    name: messages.home,
    item: '/',
  };
  const articlePage = {
    name: heading,
    item: `/${customFolder || ARTICLE_SLUGS_BY_TYPE[articleType]}/${
      story.slug
    }`,
  };
  if (isStandalonePage) {
    return [homePage, articlePage];
  }
  return [homePage, mainPage, articlePage];
};

export default createArticleBreadcrumbs;
